import { mount } from 'svelte';
import './app.css';
import App from './App.svelte';
import { store } from '$lib/store.svelte';
import { timer } from '$lib/timer.svelte';

const app = mount(App, { target: document.getElementById('app')! });

// Bootstrap deliberately happens here rather than in an `$effect`. Both of these
// write reactive state as they run, and an effect that writes state it also
// reads re-triggers itself — which showed up as `effect_update_depth_exceeded`
// and a permanent "Loading…" screen.
void store.init();
void timer.init();

export default app;
